import _classCallCheck from "/Users/newslaundry/Desktop/nishan/newslaundry/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/newslaundry/Desktop/nishan/newslaundry/node_modules/@babel/runtime/helpers/esm/createClass";

var Polygon = /*#__PURE__*/function () {
  function Polygon() {
    _classCallCheck(this, Polygon);

    this._ = [];
  }

  _createClass(Polygon, [{
    key: "moveTo",
    value: function moveTo(x, y) {
      this._.push([x, y]);
    }
  }, {
    key: "closePath",
    value: function closePath() {
      this._.push(this._[0].slice());
    }
  }, {
    key: "lineTo",
    value: function lineTo(x, y) {
      this._.push([x, y]);
    }
  }, {
    key: "value",
    value: function value() {
      return this._.length ? this._ : null;
    }
  }]);

  return Polygon;
}();

export { Polygon as default };